<template>
  <el-container class="patient-page"
                v-loading="relationShipListLoading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(0, 0, 0, 0.5)">
    <el-header>
      <!-- <Header ref="header"></Header> -->
    </el-header>
    <el-main>
      <div class="patient-page-container">
        <!--左侧信息展示-->
        <div class="patient-page-left">
          <div class="tool-bar">
            <el-button @click="goBack()" type="primary" size="mini">返回</el-button>
            <div v-if="showComponent">今日已提交: {{ tasks.submitNumber }}人</div>
          </div>
          <UserCard ref="userCard" v-if="patientData.patientId && showComponent"
                    :patientData="patientData"></UserCard>
          <div style="width: 400px;margin-top: 10px;">
            <el-tabs type="border-card">
              <el-tab-pane label="参考信息">
                <referenceInformation ref="referenceInfo" v-if="patientData.patientId&& showComponent"
                                      :patientData="patientData"></referenceInformation>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
        <!--问卷部分-->
        <div class="patient-page-right " :class="{'stretchall':stretchall}">
          <div class="qs-header">

            <span class="qs-header-label">问卷信息</span>
            <div>
              <span v-if="patientData.lastFollowupTime">上次随访时间：</span>
              {{ patientData.lastFollowupTime }}
              <!--<el-switch-->
              <!--v-model="qsSwich"-->
              <!--active-color="#248cfa"-->
              <!--inactive-color="#606266"-->
              <!--active-text="全部展示">-->
              <!--</el-switch>-->
            </div>
            <!--<el-button type="text" icon="el-icon-s-unfold" class="stretch" @click="stretchall=true"-->
            <!--v-if="!stretchall"></el-button>-->
            <!--<el-button type="text" icon="el-icon-s-fold" class="stretch" @click="stretchall=false"-->
            <!--v-if="stretchall"></el-button>-->
          </div>
          <div class="qs-content" style="height: 665px;">
            <question-new v-if="showComponent && patientData.isNewTask" :admitNo="patientData.admitNo"
                          :taskId="getTaskCenterId"></question-new>
            <question-tree-node
                v-if="showComponent && patientData.followupPatientId && qsLoaded && !patientData.isNewTask"
                :patientId="followupPatientId_p" :taskId="getTaskCenterId"
                ref="questionTreeNode"></question-tree-node>

          </div>
          <div style="text-align: right; padding-right: 15px">
            <el-button @click="submitHandler" type="primary">提交并跳转下一位</el-button>
          </div>
        </div>
      </div>
    </el-main>
    <el-footer>
      <Footer></Footer>
    </el-footer>
  </el-container>
</template>
<script type="text/ecmascript-6">
//====================新问卷v3===================
import questionNew from '../question_Third/question'

import referenceInformation from '../referenceInformation/referenceInformation'
import followupHistoryList from '../referenceInformation/followupHistoryList'
// 患病者-- 资料页
import UserCard from '../patient/UserCard.vue'
import UserPhone from '../patient/UserPhone.vue'
import UserRemark from '../patient/UserRemark.vue'
import Header from '../common/Header'
import Footer from '../common/Footer'
import PatientInHospital from '../patient/patientInHospital/patientInHospitalIndex' //患者报告列表
import lastFollowResult from '../followInfo/lastFollowResult'  // 上次随访结果
import _ from 'lodash'
import questionTreeNode from '../questionPreview/question-root-node-new'
import {
  RestNewFollowupCallCenterServiceAddSubmitRecord,
  RestNewFollowupCallCenterServiceGetPatientInfoQuestionnaire,
  RestNewFollowupCallCenterServiceGetSeatsFollowupTaskStatisticsInfo,
  RestFeedbackOutControllerIsRemind,
  RestNewFollowupCallCenterServiceGetFollowUpPatientCondition,
  RestNewFollowupCallCenterServiceGetTodayFollowupCount,
  RestFeedbackOutControllerUpdateRecordList,
  RestFeedbackOutControllerGetRecordList,
  RestNewFollowupCallCenterServiceGetFollowupTaskPatientInfo,// 获取随访任务患者信息
  RestNewFollowupCallCenterServiceGetAbnormalFollowupTaskPatientInfo,//获取随访任务异常患者信息
  RestNewFollowupCallCenterServiceGetIncompleteFollowupTaskPatientInfo,//获取随访任务未完成随访任务的患者信息
  RestNewFollowupCallCenterServiceGetCallLaterFollowupTaskPatientInfo,//稍后拨打
  RestNewFollowupCallCenterServiceGetFollowupPatientContactInformationList,// 获取患者的联系方式
  RestNewFollowupCallCenterServiceGetFollowupPatientRemarks,// 获取随访患者的备注
  RestNewFollowupCallCenterServiceUpdateFollowupPatientRemarks,// 更新随访患者的备注信息
  RestNewFollowupCallCenterServiceUpdateFollowupPatient,// 更新随访患者信息
  RestNewFollowupCallCenterServiceUpdateFollowupTaskAbnormalCall,// 设置患者为异常呼叫
  RestNewFollowupCallCenterServiceGetFollowupTaskReplayPatientInfo,
  RestNewFollowupCallCenterServiceGetFollowUpTodayCompletePatientInfo,
  RestReferenceControllerGetFollowupSpotCheckRemarksList,  //历史抽查记录
  RestNewFollowupCallCenterServiceGetCallLaterFollowupTaskPatientInfoList, //获取抽查列表
  RestNewFollowupCallCenterServiceGetAbnormalFollowupTaskPatientInfoList,
  RestFeedbackOutControllerAddFollowupQualityTime, //质控开始时间
  RestFeedbackOutControllerUpdateFollowupQualityTime, //质控结束时间
  RestNewFollowupCallCenterServiceUpdateAbnormalCallOrCallLater, //更新随访任务异常呼叫或稍后拨打
  RestNewFollowupCallCenterServiceUpdateFollowUpPatientInfoByParams, //是否复核
  RestFeedbackOutControllerGetFollowupPatientReview
} from "@src/assets/js/api.js";
import {mapGetters, mapMutations, mapState} from 'vuex';
import errorHandleMixin from "@mixins/errorHandleMixin";
import TimePicker from 'components/timePicker/indexNew.vue'

export default {
  name: 'callPatientMain',
  data() {
    var validateDeathTime = (rule, value, callback) => {
      console.log("fdsfasdfs", value);
      if (value && value.yearSelect) {
        callback();
      } else {
        callback("请选择患者死亡时间");
      }
    };
    return {
      loading: null,
      tasks: {submitNumber: null},
      isRemind: false,
      // taskId: null,
      showMask: false,
      phoneCallStateList: [
        {code: 1, codeName: '稍后拨打'},
        {code: 2, codeName: '仅随访该号码'},
        {code: 3, codeName: '短信随访成功'},
        {code: 4, codeName: '电话随访成功'},
        {code: 5, codeName: '初始化'},
        {code: 6, codeName: '挂断（接通）'},
        {code: 7, codeName: '无人接听'},
        {code: 8, codeName: '挂断（未接通）'},
        {code: 9, codeName: '停机'},
        {code: 10, codeName: '关机'},
        {code: 11, codeName: '拒随'},
        {code: 12, codeName: '空号'},
        {code: 13, codeName: '错号'},
        {code: 14, codeName: '不知情'},
        {code: 15, codeName: '沟通不畅'}], // 电话状态列表
      finishStatus: '',
      followupTypeSign: 0,
      followupNum: null,
      confirmParams: {},
      multipleSelection: [],
      callRecordList: [],
      callRecordListVisible: false,
      showComponent: true,
      stretchall: false,
      qsSwich: false,// 是否展示全部问卷
      timeToNow: {},
      patientData: {},// 获取患者的信息
      saveRemarkIng: false,
      form: {
        remark: '',
      },
      isCalling: false,
      follow: {
        isDeath: null,
        followStatus: "",
        deathTime: {},
        deathReason: "",
      },
      followRules: {
        deathTime: [
          {required: true, validator: validateDeathTime, trigger: 'blur'}
        ],
        deathReason: [
          {required: true, message: '请填写死亡原因', trigger: 'blur'}
        ],
      },
      relationShipListLoading: false,
      refuseFinsh: false,// 拒绝随访
      successFinsh: false,// 成功随访
      hasFinsh: false,
      abnormalLoading: false,// 点击异常患者loading
      finishConfirm: false,//点击结束随访患者loading
      qsLoaded: true,
      lostStatus: false,// 失访
      checklist: [],
      followupPatientId_p: '',//问卷  用
      followupQualityId: null, //质控时间 用
      abnormalDialogShow: false,
      afterCall: {
        afterCallChecked: false, //是否选择稍后拨打
        afterCallTime: null
      },
      pickerOptions: {
        shortcuts: [
          {
            text: '明天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24);
              picker.$emit('pick', date)
            }
          },
          {
            text: '后天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 2);
              picker.$emit('pick', date)
            }
          },
          {
            text: '一周之后',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() + 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date)
            }
          }
        ],
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 3600 * 1000;
        },
      },
      afterCallFormRule: {
        afterCallTime: [
          {required: true, message: '请填写日期', trigger: 'trigger'},
          {validator: this.nextTimeValidator, trigger: 'trigger'}
        ],
      },
      currentPatientId: null,
      isReview: false, //是否复核
    }
  },
  computed: {
    ...mapGetters([
      'userid',
      'patientId',
      'taskValue',
      'username',
      'getTaskCenterId',
    ]),
    ...mapState([
      'taskId',
      'nextCallNumberId',
      'currentCallNumberId',
      'currentCallNumber',
      'follupTime',
      'follupTimeString',
      'contactId',
      'contactSuccessIds',
      'taskType'
    ]),
    canFinnishBtn() { //完成按钮
      if (this.hasFinish) {
        return false;
      } else {
        return true;
      }
    },
    taskType() {
      let taskType = this.$route.query.taskType && parseInt(this.$route.query.taskType, 10) || ''
      return taskType;
    },
    isAbnormal() { // 患者是正常或者异常
      return this.$route.query.abnormal != 3; //!=3是正常 3是异常
    },
  },
  watch: {
    $route: { // 监听路由的参数变化
      handler(val, old_val) { // 数据变化更新数据
        if (old_val && old_val.query.followupPatientId != val.query.followupPatientId) {
          console.log("old_val=====>", old_val);
          console.log("val=====>", val);
          this.getPatientData();
          this.getPatientRecord();
          this.getReferenceInfo();
          this.getFollowHistory();
          this.getUserCard();
          this.getTodayFollowupNum()
        }

      },
      immediate: true // 立即执行
    }

  },// 实时监听
  mixins: [errorHandleMixin],
  components: {
    questionNew,
    Header,
    Footer,
    UserCard,
    UserPhone,
    TimePicker,
    PatientInHospital,
    lastFollowResult,
    questionTreeNode,
    referenceInformation,
    followupHistoryList,
    UserRemark

  },

  // ==========进入页面时和离开页面时========
  beforeRouteLeave(to, from, next) {
    let vm = this
    if (vm.isCalling) {
      window.workbench && window.workbench.hangUp();
      this.setCurrentCalling(false)
    }
    this.updateFollowupQualityTimeAsync()
    next();
  },
  mounted() {
    let vm = this
    window.pubsub && window.pubsub.off('calling').on('calling', function () {
      console.log('-------user -- phone -- calling ', arguments)
      vm.isCalling = true;
    });
    window.pubsub && window.pubsub.off('callHangUp').on('callHangUp', function () {
      console.log('-----user -- phone --- callHangUp ', arguments)
      vm.isCalling = false;
    });
    this.followupTaskId = this.getTaskCenterId
    // 因为可能修改 bug  ，热更新 没有获取到值
    this.getPatientData();
    this.getPatientRecord();
    this.getReferenceInfo();
    this.getFollowHistory();
    this.getUserCard();
    this.getTodayFollowupNum()
  },
  methods: {
    ...mapMutations([
      "setcurrentPatient",
      "setCurrentTaskId",
      "setTaskType",
      "resetPatient",
      'removeContactId',
      'removeContactIds',
      "setCurrentCalling",
      "resetCallBackPatient"
    ]),
    //提交跳转下一位
    submitHandler() {
      this.$confirm('确认问卷已经填写完整?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.loading = this.$loading({
          lock: true,
          text: '获取下一位中请稍后.......',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        this.submitRecordAsync({
          followupPatientInfoId: this.patientData.followUpPatientInfoId,
          submitRecordId: this.patientData.submitRecordId,
        }).then(res => {
          this.callRecordListVisible = false
          this.confirmParams.spotCheckId = this.$route.query.spotCheckId
          let questionBaseInfo = JSON.parse(localStorage.getItem('questionBaseInfo')) || []
          if (questionBaseInfo.length) {
            let index = questionBaseInfo.findIndex(item => item.NO === this.admitNo)
            questionBaseInfo.splice(index, 1)
            localStorage.setItem('questionBaseInfo', JSON.stringify(questionBaseInfo))
          }
          this.updateNextCallLaterPatient();
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    getFollowUpTaskSpotCheckStatistics() {
      let params = {
        userId: this.userid,
        followupTaskId: this.getTaskCenterId,
        isFrontPage: this.$route.query.isFrontPage ? true : false
      };
      this.asyncGetStatis(params).then(data => {
        this.tasks = data.retValue;
      });
    },
    //去听录音
    rebackVideo() {
      this.callRecordListVisible = false
      this.$refs.userphone.rebackVideoAuto()
      this.finishConfirm = false
      // let isLast =
    },
    getCallState(status) {
      console.log(this.phoneCallStateList.find(item => item.code == status));
      return this.phoneCallStateList.find(item => item.code == status).codeName
    },
    handleSelectionChange(val) {
      this.multipleSelection = val.map(item => {
        return item.id
      });
    },
    async asyncGetStatis(params = {}) {
      let data = new RestNewFollowupCallCenterServiceGetSeatsFollowupTaskStatisticsInfo();
      data.p_userId = params.userId;
      data.p_followupTaskId = params.followupTaskId;
      data.p_isFrontPage = params.isFrontPage
      await data.send();
      return data.result;
    },
    // 添加质控时间--开始
    addFollowupQualityTime(fpid) {
      this.addFollowupQualityTimeAsync(fpid).then(res => {
        console.log("质控开始")
        this.followupQualityId = res.retValue
      });
    },

    //生存状态切换
    changeIsDeathHandler() {
      this.follow.followStatus = ""
    },
    cancelRecordSelect() {
      this.callRecordListVisible = false
      this.finishConfirm = false
    },
    //获取呼叫记录列表
    async getCallListAsync(p) {
      let request = new RestFeedbackOutControllerGetRecordList()
      request.p_followUpPatientInfoId = p.followUpPatientInfoId
      await request.send()
      return request.result
    },
    //提交呼叫记录RestFeedbackOutControllerUpdateRecordList
    async updateRecordList(p) {
      let request = new RestFeedbackOutControllerUpdateRecordList()
      request.p_ids = p.ids
      await request.send()
      return request.result
    },
    async getTodayFollowupNum() {
      let request = new RestNewFollowupCallCenterServiceGetTodayFollowupCount()
      request.p_seatId = sessionStorage.getItem('userid')
      request.p_taskId = this.getTaskCenterId
      await request.send()
      if (request.result.status == 0) {
        this.followupNum = request.result.retValue
      }
    },
    //=================================userPhone=========================
    /**
     * 处理挂断组件-完成
     */
    getOverFollowUp(finshStatus) {
      console.log('[finshStatus]', finshStatus == 'successFinsh');
      this.finishStatus = finshStatus
      if (finshStatus) {
        this[finshStatus] = true;
        if (finshStatus != 'lostStatus') {
          this.lostStatus = false
        }
      } else {
        this.lostStatus = false
      }
      //异常患者处理失访逻辑
      if (!this.isAbnormal) {
        if (this.refuseFinsh || this.successFinsh) {
          this.lostStatus = false
        }
      } else {
        // 正常患者
        if (finshStatus == 'lostStatus') {
          this.refuseFinsh = false
          this.successFinsh = false
        }

      }
      this.hasFinsh = true
      this.showMask = false
    },
    /**
     * 完成时候由子组件触发
     */
    getPatientData() {
      let vm = this
      this.initBaseData()
          .then(() => {
            if (this.$refs['userphone']) {
              this.$refs['userphone'].isModel = 'beMessage';
            }
            console.log("this.$route.query.abnormal========>", this.$route.query);
            this.followupPatientId_p = this.$route.query.followupPatientId;
            if (this.$route.query.isCallBack) {
              this.resetCallBackPatient()
              // this.getCallBackPatientInfos()
            } else {
              // 获取  当前用户  当前 taskType  1.随访 2.通知 3.回访 4.重播
              this.resetPatient();
              this.getCurrentPatientInfo()
                  .then(() => {
                    if (this.patientData.admitNo) {
                      this.qsLoaded = true
                      this.loading.close()
                    } else {
                      console.log("无患者");
                      this.goBack();
                    }

                  })
            }
          })

    },
    manualCall() {
      console.log("header===>refs", this.$refs.header)
      this.$refs.header.setCallingStatus()
    },
    manualCallBack(callNumber) {
      console.log("header===>refs", this.$refs.header, callNumber)
      this.$refs.userphone.manualCallBack(callNumber)
    },
    // 挂断后 ===  userPhone
    userPhoneAfterStatus() {
      this.$refs['userphone'].setCallHangUpStatusDialog();
    },
    //  保存的触发点设置为离开该随访人
    saveRemark() {
      // 重新刷新 患者hh
      this.getPatientData();
    },
    //===============================患者====================================
    initBaseData() {
      return new Promise((resolve => {
        let vm = this;
        this.refuseFinsh = false;
        this.successFinsh = false;
        this.hasFinsh = false;
        this.follow.followStatus = ""
        this.follow.isDeath = ""
        this.follow.deathTime = {}
        this.follow.deathReason = ""
        this.qsLoaded = false
        resolve()
      }))

    },
    getCurrentPatientInfo() {
      return new Promise((async resolve => {
        let vm = this;
        let params = {
          userId: this.userid,
          taskId: this.getTaskCenterId,
          seatId: sessionStorage.getItem('userid')
        };

        //TODO 正常患者处理
        await this.getPatientInfoQuestionnaireAsync(params).then((data) => {
          if (data.status == 0) {
            vm.patientData = data.retValue || {}
            vm.setcurrentPatient(data.retValue);
            this.followupPatientId_p = data.retValue.followupPatientId; //查询问卷所需的followupPatientId
            vm.setCurrentTaskId(data.retValue.id);
            //获取患者的联系方式
            vm.asyncGetPatientContacks(data.retValue.patientId);
            vm.currentPatientId = data.retValue.patientId
            // 获取患者的备注信息
            vm.asyncGetPatientRemarks(data.retValue.followupPatientId);
            vm.getPatientRecord()
            vm.refreshComponent()
            this.getFollowUpTaskSpotCheckStatistics()
            this.getReferenceInfo();
            this.getFollowHistory();
            this.getUserCard();
            this.getRemarksList(data.retValue.followupPatientId);
            vm.getLastResult()
            this.addFollowupQualityTime(data.retValue.followupPatientId);
            vm.getFollowupPatientReviewAsync(); //复核
          } else {
            console.log("无患者");
            this.$message.error(data.desc)
            this.goBack();
          }
        }).catch(err => {
          vm.errorHandle(err);
          console.log("无患者");
          this.goBack();
          this.relationShipListLoading = false;
        })

        resolve()
      }))
    },
    getPatientError() {
      // 获取任务信息失败
      let vm = this;
      vm.$router.go(-1)
    },
    afterCallChangeHandle() {
      if (!this.afterCall.afterCallChecked) {
        this.afterCall.afterCallTime = null
      }
    },
    nextTimeValidator(rule, value, callback) {
      if (value) {
        let selectTime = new Date(value).getTime()
        let now = new Date().getTime();
        if (selectTime < now) {
          callback('选择的时间必须为未来时间')
        } else {
          callback()
        }
      } else {
        callback()
      }
    },

    getIsDeath(val) {
      switch (val) {
        case 1:
          return false;
          break
        case 2:
          return true;
          break
        case 3:
          return false;
          break
      }
    },
    // 点击完成
    finishAgainConfirm() {
      let vm = this;
      if ([9, 10, 11].indexOf(this.follow.followStatus) == -1) {
        this.$message.error('随访状态未选择')
        return
      }
      vm.$refs.userphone.checkSubmitStatus()
          .then(res => {
            if (res) {
              var messageObj = {
                9: 3,
                10: 2,
                11: 1,
                12: 0,
              }
              var params = {
                userId: this.userid,
                followupPatientId: vm.patientData.followupPatientId,
                followUpPatientInfoId: vm.patientData.followUpPatientInfoId,
                followupTaskId: this.getTaskCenterId,
                followupState: vm.follow.followStatus,
                followupMode: vm.$refs.userphone.followupModeChecked ? 2 : 1,
                followupCooperate: messageObj[vm.follow.followStatus],
                followupType: 2,
                isDeath: this.getIsDeath(this.follow.isDeath),
                followupTime: "",
                followupTypeSign: this.followupTypeSign,
                followupSource: this.$route.query.followupSource
              }
              if (this.follow.isDeath == 2) {
                vm.$refs['followForm'].validate((valid) => {
                  if (valid) {
                    params.isDeath = true;
                    params.deathTime = vm.follow.deathTime.yearSelect + '-' + vm.follow.deathTime.monthSelect + '-' + vm.follow.deathTime.daySelect
                    params.deathReason = vm.follow.deathReason
                    this.sureFinshPatient(params)
                  }
                })
              } else {
                this.sureFinshPatient(params)
              }
            } else {
              return
            }
          })
      this.isRemindAsync()
          .then(res => {
            console.log(res);
            this.isRemind = res.retValue
          })
    },
    hideCode(str, frontLen, endLen) {
      var len = str.length - frontLen - endLen;
      var xing = '';
      for (var i = 0; i < len; i++) {
        xing += '*';
      }
      return str.substring(0, frontLen) + xing + str.substring(str.length - endLen);
    },
    sureFinshPatient(params) {
      let vm = this;
      if (!vm.finishConfirm) {
        vm.finishConfirm = true;
        vm.$refs.userRemark.submitResult()
        this.getCallListAsync({followUpPatientInfoId: this.patientData.followUpPatientInfoId})
            .then(res => {
              console.log(res);
              this.confirmParams = params
              this.callRecordListVisible = true
              this.callRecordList = res.retValue.map(item => {
                item.contactTime = this.secondText(item.contactTime)
                item.phoneNumber = this.hideCode(item.phoneNumber + "", 3, 4)
                return item
              })

            })

        //TODO   确认 按钮
        //坑
      }
    },
    secondText(val) {
      let value = val;
      var theTime = parseInt(value); // 秒
      var middle = 0; // 分
      var hour = 0; // 小时
      if (theTime >= 60) {
        middle = parseInt(theTime / 60);
        theTime = parseInt(theTime % 60);
        if (middle >= 60) {
          hour = parseInt(middle / 60);
          middle = parseInt(middle % 60);
        }
      }
      var result =
          parseInt(theTime) < 10
              ? "0" + parseInt(theTime)
              : "" + parseInt(theTime);
      var middleText =
          parseInt(middle) < 10 ? "0" + parseInt(middle) : "" + parseInt(middle);
      result = middleText + ":" + result;
      if (hour > 0) {
        result = parseInt(hour) + ":" + result;
      }
      return result;
    },
    refreshComponent() {
      this.showComponent = false
      setTimeout(() => {
        this.showComponent = true
      }, 200)
      this.$forceUpdate()
    },
    /**
     * 获取患者的检查报告
     */
    getPatientRecord() {
      let vm = this;
      if (vm.$refs['patientRecord']) {
        vm.$refs['patientRecord'].getRecrods()
      }
    },
    getReferenceInfo() {
      let vm = this;
      if (vm.$refs['referenceInfo']) {
        vm.$refs['referenceInfo'].getReferenceInfo()
      }
    },
    getFollowHistory() {
      let vm = this;
      if (vm.$refs['followHistory']) {
        vm.$refs['followHistory'].getReferenceInfo()
      }
    },
    getUserCard() {
      let vm = this;
      if (vm.$refs['userCard']) {
        vm.$refs['userCard'].init()
      }
    },
    getRemarksList(id) {
      let vm = this;
      let params = {
        followUpPatientId: vm.$route.query.followupPatientId || id,
        followupTaskId: vm.getTaskCenterId
      }
      vm.getFollowupSpotCheckRemarksListAsync(params).then(res => {
        this.checklist = res.retValue;
        this.checklist = res.retValue.map(item => {
          item.handleResultName = this.getHandleresult(item.handleResult);
          let stateArr = item.firstSpotCheckState.substr(1, item.firstSpotCheckState.length - 2).split(',');
          stateArr = stateArr.map(it => {
            return this.getSpotCheckState(it)
          })
          console.log('hhhhhhhh', stateArr)
          item.firstSpotCheckStateStr = stateArr.join(',')
          return item
        })
      });
    },
    getSpotCheckState(state) {
      switch (state) {
        case '8':
          return '问题遗漏'
          break
        case '9':
          return '随访态度'
          break
        case '10':
          return '录音缺失'
          break
        case '11':
          return '记录错误'
          break
        case '15':
          return '思路清晰'
          break
        case '16':
          return '收集完整'
          break
        case '17':
          return '态度良好'
          break
        case '18':
          return '记录准确'
          break
      }
    },
    getHandleresult(state) {
      switch (state) {
        case 1:
          return '需重拨'
          break
        case 2:
          return '需注意'
          break
        case 3:
          return '平台相关'
          break
        case 4:
          return '需修改问卷'
          break
      }
    },
    /**
     * 获取患者上次的随访记录
     */
    getLastResult() {
      let vm = this;
      if (vm.$refs['lastFollowResult']) {
        vm.$refs['lastFollowResult'].asyncGetFollowResultByAdminNo({admitNo: this.patientData.admitNo})
      }
    },
    judgeStatus(status) {
      if (this.$route.query.abnormal == 5 || this.$route.query.abnormal == 6) {
        this.$router.go(-1)
        return
      } else {
        var messageObj = {
          9: '本患者已经标记为完成状态，获取下一个患者信息',
          10: '本患者已经标记为失访状态，获取下一个患者信息',
          11: '本患者已经标记为拒绝随访状态，获取下一个患者信息',
          12: '本患者已经标记为死亡状态，获取下一个患者信息',
          5: '本患者进入任务池，获取下一个患者信息',
        }
        this.$notify({
          title: '提示',
          message: messageObj[status],
          duration: 3000
        });
        this.$refs.userphone.followupModeChecked = false
        this.saveRemark();
      }
    },
    updateNextAbnormalPatient() {
      let params = {
        userId: this.userid,
        followupTaskId: this.getTaskCenterId,
        currentPage: 1,
        pageSize: 10
      };
      this.getAbnormalFollowupListAsync(params).then(res => {
        if (res.retValue.length > 0) {
          this.updatePage(3, res.retValue[0])
        } else {
          console.log("无患者");
          this.goBack();
        }
      });
    },
    updateNextCallLaterPatient() {
      let params = {
        userId: this.userid,
        taskId: this.getTaskCenterId,
        seatId: sessionStorage.getItem('userid')
      };
      this.refreshComponent()
      this.getCurrentPatientInfo()
          .then(() => {
            this.loading.close()
          })
    },
    updatePage(num, params) {
      this.$router.push({
        path: "/completeQuestion",
        query: {
          abnormal: num,
          followUpPatientInfoId: params.followUpPatientInfoId,
          followupPatientId: params.followupPatientId,
          diseaseId: this.$route.query.diseaseId,
          patientId: params.patientId,
          followupSource: 1,
          isFrontPage: this.$route.query.isFrontPage ? true : false
        }
      });
    },
    goBack() {
      this.$router.go(-1)
    },
    // 是否是今日时间
    compareDate(gettime) {
      var year = new Date().getFullYear()
      var month = new Date().getMonth() + 1 < 10 ? `0${new Date().getMonth() + 1}` : new Date().getMonth() + 1
      var day = new Date().getDate() < 10 ? `0${new Date().getDate()}` : new Date().getDate()
      let today = `${year}-${month}-${day}`
      let date = gettime.split(' ')[0]
      if (today == date) {
        return true;
      } else {
        return false;
      }
    },
    // 是否复核
    isReviewChange() {
      this.updateFollowUpPatientInfoAsync()
    },
    // ==================================async 请求====================================
    async isRemindAsync() {
      let request = new RestFeedbackOutControllerIsRemind()
      request.p_followUpPatientInfoId = this.patientData.followUpPatientInfoId
      request.p_followUpTaskId = this.getTaskCenterId
      request.p_isSingleDuration = this.$route.query.isSingleDuration
      request.p_isTotalDuration = this.$route.query.isTotalDuration
      await request.send()
      return request.result
    },
    /**
     * 正常随访任务患者信息
     */
    async asyncGetNormalPatientInfo(params) {
      let vm = this;
      let info = new RestNewFollowupCallCenterServiceGetFollowupTaskPatientInfo();
      info.p_userId = params.userId;
      info.p_followupTaskId = vm.getTaskCenterId || null;
      await info.send()
      if (info.result.status == 0) {
        return info.result
      } else if (info.result.status == -2) {
        vm.errorHandle(info.result);
        vm.getPatientError()
        return {}
      } else {
        vm.errorHandle(info.result);
        return {}
      }
    },
    /**
     * 获取随访任务异常患者信息
     */
    async asyncGetAbNormalPatientInfo(params) {
      let vm = this;
      let info = new RestNewFollowupCallCenterServiceGetAbnormalFollowupTaskPatientInfo();
      info.p_patientId = params.patientId;
      info.p_followupTaskId = vm.getTaskCenterId || null;
      info.p_followupPatientId = params.followupPatientId;
      info.p_followUpPatientInfoId = params.followUpPatientInfoId;
      await info.send()
      if (info.result.status == 0) {
        return info.result
      } else if (info.result.status == -2) {
        vm.errorHandle(info.result);
        vm.getPatientError()
        return {}
      } else {
        vm.errorHandle(info.result);
        return {}
      }
    },
    async getFollowUpPatientConditionAsync(patientId) {
      let request = new RestNewFollowupCallCenterServiceGetFollowUpPatientCondition()
      request.p_followupTaskId = this.getTaskCenterId
      request.p_patientId = patientId
      await request.send()
      return request.result
    },
    /**
     * 获取随访任务未完成的患者信息
     */
    async asyncGetIncompletePatientInfo(params) {
      let vm = this;
      let info = new RestNewFollowupCallCenterServiceGetIncompleteFollowupTaskPatientInfo();
      info.p_userId = params.userId;
      info.p_followupTaskId = vm.getTaskCenterId || null;
      await info.send()
      if (info.result.status == 0) {
        return info.result
      } else if (info.result.status == -2) {
        vm.errorHandle(info.result);
        vm.getPatientError()
        return {}
      } else {
        vm.errorHandle(info.result);
        return {}
      }
    },
    //获取重播患者详情
    async getFollowupTaskReplayPatientInfoAsync(params) {
      let request = new RestNewFollowupCallCenterServiceGetFollowupTaskReplayPatientInfo()
      request.p_followupPatientId = params.followupPatientId
      request.p_userId = params.userId
      request.p_followupTaskId = this.getTaskCenterId
      request.p_followUpPatientInfoId = params.followUpPatientInfoId
      await request.send()
      return request.result
    },
    /**
     * 获取随访任务稍后拨打的患者信息
     */
    async asyncGetcallLaterNumberPatientInfo(params) {
      let vm = this;
      let info = new RestNewFollowupCallCenterServiceGetCallLaterFollowupTaskPatientInfo();
      // info.p_userId = params.userId;

      info.p_patientId = params.patientId;
      info.p_followupTaskId = vm.getTaskCenterId || null;
      info.p_followupPatientId = params.followupPatientId;
      info.p_followUpPatientInfoId = params.followUpPatientInfoId;
      await info.send()
      if (info.result.status == 0) {
        return info.result
      } else if (info.result.status == -2) {
        vm.errorHandle(info.result);
        vm.getPatientError()
        return {}
      } else {
        vm.errorHandle(info.result);
        return {}
      }
    },
    /**
     * 获取今日随访完成的患者详情
     * @constructor
     */
    async asyncGetFollowUpTodayCompletePatientInfo(params) {
      let vm = this;
      let info = new RestNewFollowupCallCenterServiceGetFollowUpTodayCompletePatientInfo();
      info.p_followupState = params.followupState;
      info.p_followupTaskId = params.followupTaskId;
      info.p_followupPatientId = params.followupPatientId;
      await info.send()
      if (info.result.status == 0) {
        return info.result
      } else if (info.result.status == -2) {
        vm.errorHandle(info.result);
        vm.getPatientError()
        return {}
      } else {
        vm.errorHandle(info.result);
        return {}
      }
    },
    /**
     * 获取患者联系方式
     * @param patientId
     * @returns {Promise<void>}
     */
    async asyncGetPatientContacks(patientId) {
      let vm = this;
      let info = new RestNewFollowupCallCenterServiceGetFollowupPatientContactInformationList();
      info.p_patientId = patientId || 124684;
      info.p_followupTaskId = vm.getTaskCenterId
      await info.send()
      if (info.result.status == 0) {
        if (vm.$refs['userphone']) {
          vm.$refs['userphone'].getPatientList(info.result.retValue);
          // vm.manualCallBack(vm.$route.query.callNumber)
          //如果有最近拨打的患者才会调用

          vm.$refs.userphone.checkHasLastCallUser()
              .then(result => {
                // result: true代表没有拨打过
                if (result) {
                  this.hasFinsh = true
                  // if(result == 4) {
                  //     // 重拨
                  //     this.finishStatus = 'successFinsh'
                  // }else {
                  //     this.finishStatus = ''
                  // }
                  this.finishStatus = ''
                } else {
                  this.hasFinsh = false
                }
              })
          if (this.$route.query.followupSource == 2 && !this.hasFinsh) {
            // this.showMask = true   // 重播进入的页面，也要求能直接选择随访情况
            vm.getFollowUpPatientConditionAsync(patientId)
                .then(res1 => {
                  console.log(res1);
                  this.follow.followStatus = res1.retValue.followupState
                  this.follow.isDeath = res1.retValue.existenceState ? 2 : (res1.retValue.followupState == 10 ? 3 : 1)
                  this.follow.deathReason = res1.retValue.deathReason
                  let timearr = res1.retValue.deathTime.split('-')
                  this.follow.deathTime = {
                    yearSelect: timearr[0],
                    monthSelect: timearr[1],
                    daySelect: timearr[2]
                  }
                })
          }
        }
      } else {
        vm.errorHandle(info.result);
      }
    },
    async getPatientContacksAsync() {
      let request = new RestNewFollowupCallCenterServiceGetFollowupPatientContactInformationList()
      request.p_patientId = this.$route.query.patientId || this.currentPatientId
      request.p_followupTaskId = this.getTaskCenterId
      await request.send()
      return request.result
    },
    /**
     * 获取随访患者的备注信息
     * @param patientId
     * @returns {Promise<void>}
     */
    async asyncGetPatientRemarks(patientId) {
      let vm = this;
      let info = new RestNewFollowupCallCenterServiceGetFollowupPatientRemarks();
      info.p_followupPatientId = patientId;
      await info.send()
      if (info.result.status == 0) {
        vm.form.remark = info.result.retValue;
      } else {
        vm.form.remark = ""
      }
    },
    /**
     * 更新随访患者的备注信息
     * @returns {Promise<void>}
     */
    async asyncUpdatePatientRemarks() {
      let vm = this;
      let info = new RestNewFollowupCallCenterServiceUpdateFollowupPatientRemarks();
      info.p_followupPatientId = vm.patientData.followupPatientId;
      info.p_followupRemarks = vm.form.remark;

      await info.send();
      vm.saveRemarkIng = false;
      if (info.result.status != 0) {
        vm.$message.error("备注更新失败,请及时联系相关技术（吴明份、吕明涛）")
      }

    },
    /**
     * 更新随访患者信息
     * @return {Promise<void>}
     */
    async asyncUpdatePatientFollowResult(params) {
      let vm = this;
      let info = new RestNewFollowupCallCenterServiceUpdateFollowupPatient();
      for (var keys in params) {
        info['p_' + keys] = params[keys]
      }
      await info.send()
      if (info.result.status == 0) {
        //TODO  更新当前患者的随访信息成功
        vm.judgeStatus(vm.follow.followStatus)
        this.confirmParams = {}
      } else {
        vm.$message.error("处理患者错误:" + info.result.desc)
      }
      vm.finishConfirm = false
    },
    /**
     * 点击异常患者
     * @return {Promise<void>}
     */
    async asyncUpdateAbnormalPatientFollow() {
      let vm = this;
      let info = new RestNewFollowupCallCenterServiceUpdateFollowupTaskAbnormalCall();
      info.p_userId = this.userid;
      info.p_followUpPatientInfoId = this.patientData.followUpPatientInfoId;
      info.p_taskId = this.getTaskCenterId
      info.p_followupPatientId = vm.patientData.followupPatientId
      await info.send()
      if (info.result.status == 0) {
        vm.judgeStatus(5)
        if (this.$route.query.abnormal == 5) {
          this.$router.go(-1)
        }
      } else {
        vm.$message.error("处理异常患者错误:" + info.result.desc)
      }
      vm.abnormalLoading = false
    },
    //历史抽查记录
    async getFollowupSpotCheckRemarksListAsync(p) {
      let request = new RestReferenceControllerGetFollowupSpotCheckRemarksList();
      request.p_followUpTaskId = p.followupTaskId || null;
      request.p_followUpPatientId = p.followUpPatientId || null;
      await request.send();
      return request.result;
    },
    // 异常随访
    async getAbnormalFollowupListAsync(p) {
      let request = new RestNewFollowupCallCenterServiceGetAbnormalFollowupTaskPatientInfoList();
      request.p_userId = p.userId;
      request.p_followupTaskId = p.followupTaskId;
      request.p_pageIndex = p.currentPage;
      request.p_pageSize = p.pageSize;
      await request.send();
      return request.result;
    },
    // 稍后随访
    async getCallLaterFollowupListAsync(p) {
      let request = new RestNewFollowupCallCenterServiceGetCallLaterFollowupTaskPatientInfoList();
      request.p_userId = p.userId;
      request.p_followupTaskId = p.followupTaskId;
      request.p_pageIndex = p.currentPage;
      request.p_pageSize = p.pageSize;
      await request.send();
      return request.result;
    },
    // 更新随访任务异常呼叫或稍后拨打
    async updateAbnormalCallOrCallLaterAsync() {
      let vm = this
      let request = new RestNewFollowupCallCenterServiceUpdateAbnormalCallOrCallLater()
      request.p_userId = vm.userid,
          request.p_followUpPatientInfoId = vm.patientData.followUpPatientInfoId,
          request.p_laterCallTime = vm.afterCall.afterCallTime ? vm.afterCall.afterCallTime : null,
          request.p_patientId = vm.patientData.patientId,
          request.p_followupPatientId = vm.patientData.followupPatientId,
          request.p_followupTaskId = vm.getTaskCenterId
      await request.send()
      return request.result
    },
    // 质控开始时间 this.getTaskCenterId
    async addFollowupQualityTimeAsync(fpid) {
      let request = new RestFeedbackOutControllerAddFollowupQualityTime();
      request.p_followupPatientId = fpid;
      request.p_followUpTaskId = this.getTaskCenterId;
      request.p_spotCheckUserId = sessionStorage.getItem('userid');
      await request.send();
      return request.result;
    },
    // 质控结束时间
    async updateFollowupQualityTimeAsync() {
      let request = new RestFeedbackOutControllerUpdateFollowupQualityTime();
      request.p_id = this.followupQualityId;  //质控记录id
      console.log('质控结束');
      await request.send();
      return request.result;
    },

    async getFollowupPatientReviewAsync() {
      let vm = this
      let request = new RestFeedbackOutControllerGetFollowupPatientReview()
      request.p_followupPatientId = vm.patientData.followupPatientId,
          request.p_followupTaskId = vm.getTaskCenterId,

          await request.send()
      if (request.result.status == 0) {
        this.isReview = request.result.retValue
      } else {
        this.isReview = false
      }
    },
    async updateFollowUpPatientInfoAsync() {
      let vm = this
      let request = new RestNewFollowupCallCenterServiceUpdateFollowUpPatientInfoByParams()
      request.p_followupPatientId = vm.patientData.followupPatientId
      request.p_patientId = vm.patientData.patientId
      request.p_followUpTaskId = vm.getTaskCenterId
      request.p_isReview = vm.isReview
      request.p_userId = vm.userid
      request.P_userName = vm.username

      await request.send()
      return request.result
    },
    async getPatientInfoQuestionnaireAsync(p) {
      let request = new RestNewFollowupCallCenterServiceGetPatientInfoQuestionnaire()
      request.p_taskId = p.taskId
      request.p_seatId = p.seatId
      await request.send()
      return request.result
    },
    async submitRecordAsync(p) {
      let request = new RestNewFollowupCallCenterServiceAddSubmitRecord()
      request.p_followupPatientInfoId = p.followupPatientInfoId
      request.p_submitRecordId = p.submitRecordId
      await request.send()
      return request.result
    },

  },
}
</script>
<style lang="scss">
* {
  box-sizing: border-box;
}

.dethtime {
  .widget-container {
    width: 60%;
  }
}

.el-main {
  padding-top: 0 !important;
}

.no-data {
  p {
    margin: 40px 0 80px;
    font-size: 16px;
    color: rgba(0, 0, 0, 1);
  }

  display: table-cell;
  height: 60vh;
  vertical-align: middle;
  text-align: center;
  width: 480px;
  height: 100%;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.16), 0px 0px 2px 0px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  padding: 15px 15px 15px 20px;
  box-sizing: border-box;
  margin-top: 20px;
  margin-bottom: 20px;

}

.patient-page {
  .patient-page-container {
    display: flex;
    height: calc(100vh - 135px);

    .patient-page-left {
      width: 440px;

      .tool-bar {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 15px;
      }

      .el-tabs__content {
        height: calc(100% - 342px);
        overflow: auto;
      }

      .checklist-container {
        font-size: 15px;
        border-bottom: 1px solid #ccc;
        padding: 10px 0;
        line-height: 30px;

        .checklist-item-header {
          display: flex;
          justify-content: space-between;
        }

        .item-header-date {
          color: #909399;
        }

        .checklist-item-detail {
          border: 1px solid #ccc;
          padding: 5px;
          border-radius: 4px;
          margin-bottom: 5px;

          p {
            word-break: break-all;
            word-wrap: break-word;
          }

          ul {
            padding: 0 1em;
            list-style-type: disc !important;
            list-style-position: inside !important;
          }

          ol {
            padding: 0 1em;
            list-style-type: decimal !important;
            list-style-position: inside !important;
          }

          em {
            font-style: oblique !important;
          }

          strong {
            font-weight: bold;
          }

          .ql-size-large {
            font-size: 1.5em;
          }

          .ql-size-small {
            font-size: 0.75em;
          }

          .ql-size-huge {
            font-size: 2.5em;
          }
        }
      }
    }

    .patient-page-right {
      width: 100%;
      border: 1px solid rgba(0, 0, 0, 0.04);
      box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.08), 0px 1px 4px 0px rgba(0, 0, 0, 0.16);
      border-radius: 8px;
      transition: width .1s;

      .qs-header {
        display: flex;
        justify-content: space-between;
        height: 35px;
        align-items: center;
        background-color: #eee;
        padding: 10px;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
      }

      .stretch {
        font-size: 30px;
      }

      .qs-header-label {
        font-size: 20px;
        color: #000000;
        font-weight: 600;
      }
    }

    .stretchall {
      width: 75%;
      transition: width .3s;
    }

    .label-title {
      line-height: 28px;
      display: inline-block;
      color: #000;
      font-weight: 600;
      font-size: 16px;
    }

  }
}

</style>
<style lang="scss" scoped>
.patient-page {
  .abnormal-after-dialog {
    .content {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      font-size: 16px;

      & > div {
        min-height: 30px;
      }
    }
  }
}

</style>
